export default (uiState = [], action) => {
    switch (action.type) {
      case 'set':
        return {...uiState, sidebarShow: action.sidebarShow }
      default:
        return {  
            sidebarShow: 'responsive'
        }
    }
  }